// extracted by mini-css-extract-plugin
module.exports = {"mapMain":"NYMapDesktop_mapMain__1gDkF","hotspots":"NYMapDesktop_hotspots__3EFXj","bgMap":"NYMapDesktop_bgMap__3rRyy"};